var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixartLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "952px",
    height: "223px",
    viewBox: "0 0 952 223",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "24.9415719%",
    x2: "102.965893%",
    y2: "77.724021%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3C4FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC95FA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Path",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5812992,171.683048 C83.839326,161.40871 70.2456292,156.271542 53.800209,156.271542 C13.1959963,156.271542 -9.50651002,208.774671 28.2772174,212.601724 C128.682384,222.771602 82.4662521,34.9693232 98.6905558,16.3062858 C114.914859,-2.35675151 132.870766,126.776682 155.028515,62.5746257 C177.186263,-1.62743058 188.120276,6.88933825 188.397482,20.9162308 C188.674688,34.9431233 177.475026,177.085985 254.766343,191.668471 C339.941153,207.73833 157.336769,231.706554 94.5812992,171.683048 Z",
    id: "Path-2",
    stroke: "url(#linearGradient-1)",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "mixart",
    fontFamily: "Inter-Regular_Bold, Inter",
    fontSize: 200,
    fontWeight: "bold",
    fill: "#374151"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 324.478043,
    y: 175
  }, "mixart")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixartLogo);
export default __webpack_public_path__ + "static/media/mixart-logo.d1e311d9f67573077a406224efc4073c.svg";
export { ForwardRef as ReactComponent };